/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SharedReportChangePasswordInput = {
    sharedId: string;
    oldPassword: string;
    newPassword: string;
    clientMutationId?: string | null | undefined;
};
export type sharedReportChangePasswordMutationVariables = {
    input: SharedReportChangePasswordInput;
};
export type sharedReportChangePasswordMutationResponse = {
    readonly sharedReportChangePassword: {
        readonly viewer: {
            readonly id: string;
        } | null;
        readonly success: boolean | null;
    } | null;
};
export type sharedReportChangePasswordMutation = {
    readonly response: sharedReportChangePasswordMutationResponse;
    readonly variables: sharedReportChangePasswordMutationVariables;
};



/*
mutation sharedReportChangePasswordMutation(
  $input: SharedReportChangePasswordInput!
) {
  sharedReportChangePassword(input: $input) {
    viewer {
      id
    }
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SharedReportChangePasswordInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharedReportChangePasswordPayload",
    "kind": "LinkedField",
    "name": "sharedReportChangePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedReportChangePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedReportChangePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sharedReportChangePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation sharedReportChangePasswordMutation(\n  $input: SharedReportChangePasswordInput!\n) {\n  sharedReportChangePassword(input: $input) {\n    viewer {\n      id\n    }\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = '1f4df6eb7d26dc5c74a1da05e4f47cdc';
export default node;
